// JSON Forms gives a field to the highest-ranked tester that matches it,
// so these say which kind of match wins when two testers claim one field.
// The stock Material testers rank between 1 and 5.

// The uiType names its renderer outright.
export const UI_TYPE_RANK = 1000

// The field's schema carries a key only one custom renderer understands.
export const SCHEMA_SHAPE_RANK = 100
